import { Component, computed, EventEmitter, input, Input, model, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FilterMatchMode } from 'primeng/api';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { ButtonDirective, Button } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
@Component({
  selector: 'lib-input-filter',
  standalone: true,
  imports: [InputTextModule, Button, TranslateModule, ButtonDirective, InputGroupModule],
  templateUrl: './input-filter.component.html',
  styleUrl: './input-filter.component.scss',
})
export class InputFilterComponent {
  @Input() filterMatchMode = FilterMatchMode.CONTAINS;
  @Input() dataCy = '';
  showClearButton = input<boolean>(false);
  showClearWhenInputEmpty = computed(() => {
    return this.showClearButton() && !!this.value();
  });
  value = model<string>('');

  @Output() filtersChange = new EventEmitter<FilterMetadata>();

  search(value: string) {
    this.value.set(value);
    const filterMetadata: FilterMetadata = {
      value: value,
      matchMode: this.filterMatchMode,
    };
    this.filtersChange.emit(filterMetadata);
  }
}
